import { styled } from '@linaria/react';
import { mdiFilterVariant } from '@mdi/js';
import Icon from '@mdi/react';
import "./Filter.linaria.module.css!=!./Filter?./Filter.linaria.module.css?css=H4sIAAAAAAAAA9MrNiy2SCnIzK1Oyi9KSS3SLUpMySwttjIpqLCu5QIAbhtsTR4AAAA="
interface IFilter {
  size?: number;
}
const _exp = () => Icon;
const StyledIcon = /*#__PURE__*/styled(_exp())({
  name: "StyledIcon",
  class: "s1s8dpim",
  propsAsIs: true
});
const Filter = (props: IFilter) => {
  const {
    size = 1
  } = props;
  return <StyledIcon data-testid="IconButton__Filter" path={mdiFilterVariant} size={size} />;
};
export default Filter;